import { useTranslations } from "next-intl";
import { useSubscriptionStatus, useCurrentUser } from "@hooks/use-current-user";
import { usePrice } from "@hooks/use-prices";
import { useFormatDate } from "@hooks/use-format-date";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

function SubscriptionRecapNextInvoice({ nextInvoiceSubscriptionAmount }) {
  const t = useTranslations("accounts");

  const subscriptionStatus = useSubscriptionStatus();
  const user = useCurrentUser();
  const price = usePrice();
  const formatDate = useFormatDate();

  const nextInvoiceDate = user?.next_invoice_date;

  switch (subscriptionStatus) {
    case subscriptionStatuses.notSubscribed:
    case subscriptionStatuses.canceled:
      return null;
    case subscriptionStatuses.paused:
      return (
        <p
          className="mb-0 text-gray"
          data-testid="manage-subscription-recap-pause-restart-at-section"
        >
          {t.rich("manage_subscription.restart_at", {
            date: formatDate(user.subscription?.restart_at),
            span: (chunks) => <span className="text-dark">{chunks}</span>,
          })}
        </p>
      );
    default:
      return (
        <div data-testid="manage-subscription-recap-next-invoice-section">
          <p className="mb-0 text-gray">
            {t.rich("manage_subscription.next_invoice_amount", {
              amount:
                nextInvoiceSubscriptionAmount !== null
                  ? price(nextInvoiceSubscriptionAmount, { withoutSpace: true })
                  : "-",
              span: (chunks) => <span className="text-dark">{chunks}</span>,
            })}
          </p>
          <p className="mb-0 text-gray">
            {t.rich("manage_subscription.next_invoice_date", {
              date: formatDate(nextInvoiceDate),
              span: (chunks) => <span className="text-dark">{chunks}</span>,
            })}
          </p>
        </div>
      );
  }
}

export default SubscriptionRecapNextInvoice;
